import { createAsyncThunk } from '@reduxjs/toolkit';
import { TemplateCompartmentType } from '@/Models';
import { DocumentTemplateType } from '@/Enums/DocumentTemplateType';
import { GetDocumentsInfoResponse } from '@/Api/_Microservices/OnlineArchive/Documents/GetDocumentsInfoResponse';
import { GetDocumentsInfoRequest } from '@/Api/_Microservices/OnlineArchive/Documents/GetDocumentsInfoRequest';
import { DocumentsApi } from '@/Api/_Microservices/OnlineArchive/Documents';
import { GetAllDocumentTemplateResponse } from '@/Api/DocumentTemplates/Responses/GetAllDocumentTemplateResponse';
import { DocumentTemplateApi } from '@/Api/DocumentTemplates/DocumentTemplatesApi';

const getDocumentTemplates = createAsyncThunk<GetAllDocumentTemplateResponse, TemplateCompartmentType>(
  'documentPrintModalSlice/getAll',
  async (compartment) => {
    return DocumentTemplateApi.getAllDocumentTemplates(DocumentTemplateType.Document, compartment);
  },
);

const getDocumentsForPrint = createAsyncThunk<GetDocumentsInfoResponse, GetDocumentsInfoRequest>(
  'documentPrintModalSlice/get-documents-for-print',
  async (request) => {
    return DocumentsApi.getDocumentsInfo(request);
  },
);

export const asyncActions = {
  getDocumentTemplates,
  getDocumentsForPrint,
};
